import React from 'react';

import * as S from './Loader.styles';

interface LoaderProps {
  fullWidth?: boolean;
}

function Loader({ fullWidth }: LoaderProps) {
  return (
    <S.Container fullWidth={fullWidth}>
      <S.Image>
        <img
          src="/logo-completo.svg"
          alt="Payana"
          width="300px"
          height="100px"
        />
      </S.Image>
    </S.Container>
  );
}

export default Loader;
